import { Alert, PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'

export const StyledGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  padding: 10px;
`

export const StyledForm = styled.form`
  width: 100%;
`

export const StyledSecondaryButton = styled(SecondaryButton)`
  width: 100%;
  margin-bottom: 8px;
`

export const StyledPrimaryButton = styled(PrimaryButton)`
  width: 100%;
  margin-bottom: 8px;
`

export const AlertGutterTop = styled(Alert)`
  margin-top: 10px;
  // override margin-bottom in child element
  && > div {
    margin-bottom: 0;
  }
`
